<div class="row mt-4">
  <div class="col-md-9">
    <div class="row">
      <div class="col-md-12">
        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-3">
          <ngb-panel id="custom-panel-3">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0 font-weight-bold"><i
                    class="align-middle far fa-file-alt mr-2 fx-2 text-orange"></i>Account Information
                </h5>
                <div class="so-topright d-flex align-items-baseline">
                  <div class="detail-client-title font-weight-bold mr-3"><span class="">Access Level: </span>
                    <span class="badge {{ accesslevel ? 'badge-success':' badge-danger'}}">{{ accesslevel ?
                      "Enabled":"Disabled"}} </span>
                  </div>
                  <button ngbPanelToggle class="btn btn-link p-0 shadow-none">
                    <i class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
                </div>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Name</div>
                <div class="col-md-9">
                  {{ model.name }}
                </div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Client</div>
                <div class="col-md-9">
                  <span><a [routerLink]="['/client', model.clientId]">
                    {{model.clientName}}</a></span>
                  <span *ngIf="model.locationName">
                    (<a [routerLink]="['/client/location', model.locationId]">{{model.locationName}}</a>)</span>
                </div>
              </div>
              <!-- <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Office</div>
                <div class="col-md-9">
                  <a [routerLink]="['/client/location', model.locationId]">
                    {{model.locationName}}</a>
                </div>
              </div> -->
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Role</div>
                <div class="col-md-9">{{model.role}} </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-3x">
          <ngb-panel id="custom-panel-3x">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0 font-weight-bold"><i
                    class="align-middle far fa-file-alt mr-2 fx-2 text-orange"></i>Contact Information
                </h5>
                <button ngbPanelToggle class="btn btn-link p-0 shadow-none"> <i
                    class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Primary Email</div>
                <div class="col-md-9"><a href="mailto:{{model.billingEmail}}">{{model.email}}</a></div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Address</div>
                <div class="col-md-9">
                  <div *ngIf="model.address1">{{model.address1}}</div>
                  <div *ngIf="model.address2">{{model.address2}}</div>
                  <div *ngIf="model.address3">{{model.address3}}</div>
                  <div>
                    <span *ngIf="model.city">{{model.city}}</span>
                    <span *ngIf="model.city && model.state">,</span>
                    <span *ngIf="model.state"> {{model.state}}</span>
                    <span *ngIf="model.zipCode"> ({{model.zipCode}})</span>
                  </div>
                </div>
              </div>
              <!-- <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Home Phone</div>
                <div class="col-md-9">{{model.homePhone}} </div>
              </div> -->
              <!-- <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Contact Number</div>
                <div class="col-md-9">{{model.}}</div>
              </div> -->
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold  font-weight-bold">Fax</div>
                <div class="col-md-9">{{model.fax}}</div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-5">
          <ngb-panel id="custom-panel-5">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0 font-weight-bold"><i class="align-middle far fa-file-alt mr-2 fx-2 text-orange"></i>Other
                  Information</h5>
                <button ngbPanelToggle class="btn btn-link p-0 shadow-none"> <i
                    class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Date of Birth</div>
                <div class="col-md-9">{{model.dob}}</div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Account Code</div>
                <div class="col-md-9">{{model.accountCode}}</div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Tags</div>
                <div class="col-md-9">
                  <ng-select [multiple]="true" [(ngModel)]="model.tags" [ngClass]="'ngselectview'" [clearable]="false"
                    [disabled]="true" [searchable]="false">
                  </ng-select>
                </div>
              </div>
              <div class="row  mb-4" *ngIf="model.salesPersonName">
                <div class="col-md-3 da-font-bold font-weight-bold">Salesperson</div>
                <div class="col-md-9">
                  <a [routerLink]="['/staff', model.salesPerson]">
                    {{model.salesPersonName}}</a>
                </div>
              </div>
              <div class="row  mb-4" *ngIf="model.caseManagerName">
                <div class="col-md-3 da-font-bold font-weight-bold">Case Manager</div>
                <div class="col-md-9">
                  <a [routerLink]="['/staff', model.caseManager]">
                    {{model.caseManagerName}}</a>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-4">
          <ngb-panel id="custom-panel-4">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0 font-weight-bold"><i class="align-middle far fa-file-alt mr-2 fx-2 text-orange"></i>Notes
                </h5>
                <button ngbPanelToggle class="btn btn-link p-0 shadow-none"> <i
                    class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row mb-4" *ngIf="model.pinnedNotes && model.pinnedNotes.length > 0">
                <div class="col-md-12">
                  <app-pinned-notes-list-view [pinnedNotes]="model.pinnedNotes"></app-pinned-notes-list-view>
                </div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">General Notes</div>
                <div class="col-md-9">
                  <p>{{model.generalNotes}}</p>
                </div>
              </div>
              <div class="row  mb-4">
                <div class="col-md-3 da-font-bold font-weight-bold">Admin Notes</div>
                <div class="col-md-9">
                  <p>{{model.adminNotes}}</p>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="row " id="stickyoney">
      <div class="col-md-12">
        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-0">
          <ngb-panel id="custom-panel-0">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0  font-weight-bold">Photo</h5>
                <button ngbPanelToggle class="btn btn-link p-0 shadow-none"> <i
                    class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row">
                <div class="col-md-12 mb-3">
                  <img [src]="profileImgUrl" class="w-100 {{shimmerornot}}">
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
      <div class="col-md-12 mt-3">
        <ngb-accordion #a="ngbAccordion">
          <ngb-panel id="custom-panel-2">
            <ng-template ngbPanelHeader let-opened="opened">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0  font-weight-bold">Quick Links</h5>
                <button ngbPanelToggle class="btn btn-link p-0 shadow-none"> <i
                    class="fas  {{ opened ? 'fa-chevron-up' : 'fa-chevron-down' }}"></i></button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="row quicklinks">
                <div class="col-md-12 mb-3">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="list-group mb-3" *ngFor="let quick of quicklink; index as i; ">
                        <div class="list-group quickhead">
                          {{quick.mainmenu}}
                        </div>
                        <ul class="list-group">
                          <li class="list-group-item border-0" *ngFor="let submen of quicklink[i].submenu; index as x">
                            <a class="link" href="{{submen.link}}">{{submen.name}}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
  </div>
</div>
